"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const orders_service_1 = require("./orders.service");
const jwt_auth_guard_1 = require("../../common/guards/jwt-auth.guard");
const permissions_guard_1 = require("../../common/guards/permissions.guard");
const permissions_decorator_1 = require("../../common/decorators/permissions.decorator");
const current_user_decorator_1 = require("../../common/decorators/current-user.decorator");
const user_entity_1 = require("../users/user.entity");
const permissions_1 = require("../authorization/permissions");
let OrdersController = class OrdersController {
    constructor(svc) {
        this.svc = svc;
    }
    findAll(customerId, status) {
        return this.svc.findAll(customerId ? +customerId : undefined, status);
    }
    findOne(id) {
        return this.svc.findById(id);
    }
    create(dto, agent) {
        return this.svc.create({ ...dto, agentId: agent.id });
    }
    createDraft(dto, agent) {
        return this.svc.createDraft({ ...dto, agentId: agent.id });
    }
    updateDraft(id, dto, agent) {
        return this.svc.updateDraft(id, { ...dto, agentId: agent.id });
    }
    finalizeDraft(id, agent) {
        return this.svc.finalizeDraft(id, agent.id);
    }
    removeDraft(id) {
        return this.svc.removeDraft(id).then(() => ({ success: true }));
    }
    allocate(id) {
        return this.svc.allocateToLogistics(id);
    }
    updateLineStatus(id, body) {
        return this.svc.updateLineItemStatus(id, body.status, {
            trackingId: body.trackingId,
            carrier: body.carrier,
            dispatchDate: body.dispatchDate ? new Date(body.dispatchDate) : undefined,
            statusReason: body.statusReason,
        });
    }
    markPayment(id) {
        return this.svc.markPaymentVerified(id);
    }
    createShipment(dto) {
        return this.svc.createShipment(dto);
    }
    updateShipment(id, dto) {
        return this.svc.updateShipment(id, dto);
    }
    updateShipmentStatus(id, body) {
        return this.svc.updateShipmentStatus(id, body.status, body);
    }
};
exports.OrdersController = OrdersController;
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.ORDERS_READ),
    tslib_1.__param(0, (0, common_1.Query)('customerId')),
    tslib_1.__param(1, (0, common_1.Query)('status')),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, String]),
    tslib_1.__metadata("design:returntype", void 0)
], OrdersController.prototype, "findAll", null);
tslib_1.__decorate([
    (0, common_1.Get)(':id'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.ORDERS_READ),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", void 0)
], OrdersController.prototype, "findOne", null);
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.ORDERS_CREATE),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_b = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _b : Object]),
    tslib_1.__metadata("design:returntype", void 0)
], OrdersController.prototype, "create", null);
tslib_1.__decorate([
    (0, common_1.Post)('draft'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.ORDERS_CREATE),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_c = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _c : Object]),
    tslib_1.__metadata("design:returntype", void 0)
], OrdersController.prototype, "createDraft", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/draft'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.ORDERS_CREATE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, typeof (_d = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _d : Object]),
    tslib_1.__metadata("design:returntype", void 0)
], OrdersController.prototype, "updateDraft", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/finalize'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.ORDERS_CREATE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_e = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _e : Object]),
    tslib_1.__metadata("design:returntype", void 0)
], OrdersController.prototype, "finalizeDraft", null);
tslib_1.__decorate([
    (0, common_1.Delete)(':id/draft'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.ORDERS_CREATE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", void 0)
], OrdersController.prototype, "removeDraft", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/allocate'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.ORDERS_ALLOCATE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", void 0)
], OrdersController.prototype, "allocate", null);
tslib_1.__decorate([
    (0, common_1.Patch)('line-items/:lineItemId/status'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.ORDER_LINE_ITEMS_UPDATE_STATUS),
    tslib_1.__param(0, (0, common_1.Param)('lineItemId', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", void 0)
], OrdersController.prototype, "updateLineStatus", null);
tslib_1.__decorate([
    (0, common_1.Patch)('line-items/:lineItemId/payment-verified'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.ORDERS_MARK_PAYMENT),
    tslib_1.__param(0, (0, common_1.Param)('lineItemId', common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", void 0)
], OrdersController.prototype, "markPayment", null);
tslib_1.__decorate([
    (0, common_1.Post)('shipments'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.ORDERS_ALLOCATE),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], OrdersController.prototype, "createShipment", null);
tslib_1.__decorate([
    (0, common_1.Patch)('shipments/:id'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.ORDERS_ALLOCATE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", void 0)
], OrdersController.prototype, "updateShipment", null);
tslib_1.__decorate([
    (0, common_1.Patch)('shipments/:id/status'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.ORDER_LINE_ITEMS_UPDATE_STATUS),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", void 0)
], OrdersController.prototype, "updateShipmentStatus", null);
exports.OrdersController = OrdersController = tslib_1.__decorate([
    (0, common_1.UseGuards)(jwt_auth_guard_1.JwtAuthGuard, permissions_guard_1.PermissionsGuard),
    (0, common_1.Controller)('orders'),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof orders_service_1.OrdersService !== "undefined" && orders_service_1.OrdersService) === "function" ? _a : Object])
], OrdersController);
